import { render, staticRenderFns } from "./button_component.vue?vue&type=template&id=bffa63a4&scoped=true&"
import script from "./button_component.vue?vue&type=script&lang=js&"
export * from "./button_component.vue?vue&type=script&lang=js&"
import style0 from "./button_component.vue?vue&type=style&index=0&id=bffa63a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffa63a4",
  null
  
)

export default component.exports